<app-complex-modal-template
    [canClose]="false"
    [isConfirmationMode]="false"
    [title]="'fetchingEntities' | transloco">
    <ng-container>
        @if (errorMessage()) {
            <p class="text-error">
                {{ errorMessage() | transloco }}
            </p>
        } @else {
            <p>
                {{ 'waitFetchingEntities' | transloco }}
            </p>
        }
        <app-progress-bar
            [hasError]="!!errorMessage()"
            [itemsLoaded]="fetchEntitiesCount()"
            [total]="entitiesToFetchedCount()" />
    </ng-container>
</app-complex-modal-template>
